export const DEFAULT_ARTICLE_META_IMAGE = 'https://r.fashionunited.com/dvwru1eeHTpIq2TqFfcxEiZYw5ImERxjaYoZeRpaKIk/resize:fill:1200:630:1/gravity:ce/quality:70/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9sb2dvcy9mdV9sb2dvLlF4MkRuQ2RqOHhuRFFHMmFiLmpwZw';
export const DEFAULT_EVENT_IMAGE = 'https://r.fashionunited.com/h3m06IVmYjAJzvGasoIAVbdqUNgXQF6ps_u8fpweYbQ/resize:fill:720:0:0/gravity:ce/quality:70/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9sb2dvcy9mdV9sb2dvLlF4MkRuQ2RqOHhuRFFHMmFiLmpwZw';
export const DEFAULT_AMP_IMAGE_URLS = [
  'https://r.fashionunited.com/o8uaeN191lKoIOyCgM3f_jZAc3XcjcYQScW5n4KzLDo/resize:fill:42:0:0/gravity:ce/quality:1/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9sb2dvcy9mdV9sb2dvLlF4MkRuQ2RqOHhuRFFHMmFiLmpwZw.webp',
  'https://r.fashionunited.com/ft-63d99srCcck1twuGQyu2qn9hwdEP_fIV1UEB0Td0/resize:fill:42:0:0/gravity:ce/quality:10/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9sb2dvcy9mdV9sb2dvLlF4MkRuQ2RqOHhuRFFHMmFiLmpwZw.jpeg',
  'https://r.fashionunited.com/mwtx1RgnQwhgM5Cnr5CJGNy44RKXcCWmgxPxD2M7NFg/resize:fill:320:0:0/gravity:ce/quality:70/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9sb2dvcy9mdV9sb2dvLlF4MkRuQ2RqOHhuRFFHMmFiLmpwZw.webp',
  'https://r.fashionunited.com/99WgtssYyShoq26vsWt3V1YePUUKKIXkhpp02-Fo9bw/resize:fill:320:0:0/gravity:ce/quality:70/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9sb2dvcy9mdV9sb2dvLlF4MkRuQ2RqOHhuRFFHMmFiLmpwZw.jpeg',
  'https://r.fashionunited.com/ZBiQ4TlWbJfE-oA7nQ-D90Y5lFAhIRWTYjtteRyGFK0/resize:fill:375:0:0/gravity:ce/quality:70/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9sb2dvcy9mdV9sb2dvLlF4MkRuQ2RqOHhuRFFHMmFiLmpwZw.webp',
  'https://r.fashionunited.com/JEYQoiezM402Rbp2F5-ZgXJp6Y7-kkP1hxlMJyRL7T4/resize:fill:375:0:0/gravity:ce/quality:70/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9sb2dvcy9mdV9sb2dvLlF4MkRuQ2RqOHhuRFFHMmFiLmpwZw.jpeg',
  'https://r.fashionunited.com/T78-3fHY_7ZEj47V69FkemUkAW-nDJrGUgWNoygZtzQ/resize:fill:414:0:0/gravity:ce/quality:70/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9sb2dvcy9mdV9sb2dvLlF4MkRuQ2RqOHhuRFFHMmFiLmpwZw.webp',
  'https://r.fashionunited.com/PrA-TTg1AYs096329RU42QhthQxWhJafsjpq_lfbLzc/resize:fill:414:0:0/gravity:ce/quality:70/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9sb2dvcy9mdV9sb2dvLlF4MkRuQ2RqOHhuRFFHMmFiLmpwZw.jpeg',
  'https://r.fashionunited.com/8ZyLLHa2aVdhhqFSi9khgqfJKyPTF8IvDA8Qvfp0fGE/resize:fill:725:0:0/gravity:ce/quality:70/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9sb2dvcy9mdV9sb2dvLlF4MkRuQ2RqOHhuRFFHMmFiLmpwZw.webp',
  'https://r.fashionunited.com/LGA_RcwshGNYGGN7NdFGc6iCwDf4l5930PwX9qzGEgQ/resize:fill:725:0:0/gravity:ce/quality:70/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9sb2dvcy9mdV9sb2dvLlF4MkRuQ2RqOHhuRFFHMmFiLmpwZw.jpeg',
  'https://r.fashionunited.com/ShbP9TQJMLNmpjOrnbYoQLStixtLef-1pBembiLQT3Y/resize:fill:740:0:0/gravity:ce/quality:70/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9sb2dvcy9mdV9sb2dvLlF4MkRuQ2RqOHhuRFFHMmFiLmpwZw.webp',
  'https://r.fashionunited.com/ZE5m2JdESLbuivit1n27NzjVEX_5XHF9D8FhvTQhV8Q/resize:fill:740:0:0/gravity:ce/quality:70/aHR0cHM6Ly9mYXNoaW9udW5pdGVkLmNvbS9sb2dvcy9mdV9sb2dvLlF4MkRuQ2RqOHhuRFFHMmFiLmpwZw.jpeg',
];
export const categories = [8, 9, 10, 11, 12, 13, 27, 36, 38];

export const metaImageDimensions = { width: 1200, height: 630 }; // source: https://developers.facebook.com/docs/sharing/webmasters/images/

export const sponsorIds = {
  auFashionunitedComNewsArticles: 586,
  fashionunitedBeFrNewsArticles: 567,
  fashionunitedBeNewsArticles: 605,
  fashionunitedCaFrNewsArticles: 565,
  fashionunitedCaNewsArticles: 588,
  fashionunitedChNewsArticles: 589,
  fashionunitedClNewsArticles: 568,
  fashionunitedCnNewsArticles: 586,
  fashionunitedComArNewsArticles: 568,
  fashionunitedComNewsArticles: 601,
  fashionunitedComPeNewsArticles: 568,
  fashionunitedCoNewsArticles: 568,
  fashionunitedDeNewsArticles: 592,
  fashionunitedEsNewsArticles: 579,
  fashionunitedFrNewsArticles: 578,
  fashionunitedInfoNewsArticles: 577,
  fashionunitedInNewsArticles: 586,
  fashionunitedItNewsArticles: 588,
  fashionunitedMxNewsArticles: 568,
  fashionunitedNlNewsArticles: 606,
  fashionunitedNzNewsArticles: 588,
  fashionunitedRuNewsArticles: 586,
  fashionunitedUkNewsArticles: 601,
  fashionweekwebComNewsArticles: 577,
  internationalfashionjobsComNewsArticles: 570,
  newsArticles: 1023,
};

export const partners = {
  'fashionunited.in': 20_228,
  'fashionunited.ca': 8705,
  'fashionunited.ca/fr': 12_817,
  'fashionunited.com': 21_925,
  'au.fashionunited.com': 7400,
  'fashionunited.be/fr': 15_321,
  'fashionunited.be': 24_607,
  'fashionunited.ch': 17_023,
  'fashionunited.cn': 2708,
  'fashionunited.co': 25_801,
  'fashionunited.nz': 7154,
  'fashionunited.cl': 25_949,
  'fashionunited.com.ar': 25_835,
  'fashionunited.com.pe': 25_892,
  'fashionunited.de': 30_729,
  'fashionunited.es': 29_303,
  'fashionunited.fr': 19_717,
  'fashionunited.it': 19_094,
  'fashionunited.mx': 25_927,
  'fashionunited.nl': 41_154,
  'fashionunited.ru': 24_614,
  'fashionunited.uk': 41_172,
  'fashionunited.ie': 86_525,
  'fashionunited.com.br': 86_525,
  'fashionunited.jp': 86_525,
  'fashionweekweb.com': 86_525,
};
